"use client";
import { OMS_FEATURES_COMP } from "./features.constants";
import CardsList from "@/components/cardsList";

const OMSFeatures = () => {
  return <CardsList list={OMS_FEATURES_COMP.list} title={OMS_FEATURES_COMP.title} />;
};

export default OMSFeatures;
